// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4520":"7ea3c7f4","4950":"c6353821","9869":"f7bde30c"}[chunkId] + ".chunk.css";
};